import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/utils/utils';
import { MessageService } from 'primeng/api';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { EleitorService } from 'src/app/services/eleitor.service';
import { LoginService } from 'src/app/services/login.service';
import { Eleitor } from '../../../models/eleitor.model';
import { NewEleitorDTO } from '../../../models/newEleitorDTO.model';
import { sha256 } from 'js-sha256';

@Component({
  selector: 'app-gerar-nova-senha',
  templateUrl: './gerar-nova-senha.component.html',
  styleUrls: ['./gerar-nova-senha.component.css']
})
export class GerarNovaSenhaComponent implements OnInit {

  formGroup: FormGroup;
  isSubmit: boolean = false;
  labelAuth1: string = "Autenticação 1";
  labelAuth2: string = "Autenticação 2";
  eleitor: any = { id: null, idEleicao: null};

  constructor(
    protected formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public utils: Utils,
    public routes: ActivatedRoute,
    public route: Router,
    protected eleicaoService: EleicaoService,
    private eleitorService: EleitorService,
    private loginService: LoginService,
    protected messageService: MessageService
  ) { }

  async ngOnInit() {
    this.formGroup = new FormGroup({
      login: new FormControl(),
      senha: new FormControl(),
      confirmaSenha: new FormControl(),
      auth1: new FormControl(),
      auth2: new FormControl(),
    })
    let eleicaoRota = this.routes.snapshot.params.rotaEleicao;
    this.getAuths(eleicaoRota);
    const token = "Bearer " + this.routes.snapshot.params.token;
    try {
      await this.validaToken(token);
    } catch (error) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: error });
    }
    
    this.formGroup = this.formBuilder.group({
      login: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      senha: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      confirmaSenha: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      auth1: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      auth2: ['', [Validators.required, this.utils.noWhitespaceValidator]],
    }, {
      validators: this.confirmedValidator
    });

    this.spinner.hide();
  }

  public getAuths(eleicaoRota: string) {
    this.eleicaoService.getEleicaoByRota(eleicaoRota).then((resp: any)=>{
      if (resp.labelAuth1 != null) this.labelAuth1 = resp.labelAuth1;
      if (resp.labelAuth2 != null) this.labelAuth2 = resp.labelAuth2;
    }).catch(err=>{
      this.messageService.add({ key: 'toast', severity: 'error', summary: "Atenção", detail: "Eleição não se encontra disponível para login." });
    });
  }

  private validaToken(token) {
    this.loginService.getEleitorRedefinirSenha(token).then( resp => {
      this.eleitor = resp;
    }).catch(error => {
      this.route.navigate([this.routes.snapshot.params.rotaEleicao])
    });
  }

  public async onSubmit(){
    this.isSubmit = true;
    if (!this.formGroup.valid) {
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Corrija o(s) erro(s) apontado(s) no formulário!" })
    }
    const token = "Bearer " + this.routes.snapshot.params.token;
    await this.validaToken(token);
    if (this.eleitor && this.eleitor.id) {
      let novoEleitor: NewEleitorDTO = new NewEleitorDTO();
      novoEleitor.login = sha256.update(this.formGroup.get('login').value).hex();
      novoEleitor.senha = sha256.update(this.formGroup.get('senha').value).hex();
      novoEleitor.auth1 = sha256.update(this.formGroup.get('auth1').value).hex();
      novoEleitor.auth2 = sha256.update(this.formGroup.get('auth2').value).hex();
      novoEleitor.eleicao = {id: this.eleitor.idEleicao};
      novoEleitor.idGestor = this.eleitor.idGestor;
      this.updateEleitor(novoEleitor, this.eleitor.id, token);
    } else {
      this.formGroup.get("senha").setValue('');
      this.formGroup.get("confirmaSenha").setValue('');
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Algo deu errado!" });
    }
  }

  private updateEleitor(eleitor, idEleitor, token) {
    this.eleitorService.updateEleitor(eleitor, idEleitor, token).then(() => {
      document.body.style.cursor = 'default';
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Senha atualizada com sucesso!' });
      setTimeout(() => {
        this.route.navigate([this.routes.snapshot.params.rotaEleicao])
      }, 2500);
    }, error => {
      console.log("updateEleitor: ", error);
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: "Dados de autenticação incorretos, tente novamente." });
      this.formGroup.reset();
    });
  }

  private confirmedValidator(control: FormControl){
    return control.get("senha").value !== control.get("confirmaSenha").value ? { 'notMatch': true } : null;
  }
}
